exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".value[data-v-cd0e78f6] {\n  padding: 0 0.125rem;\n  background: #000;\n  color: #fff;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n}\n", ""]);

// exports
